import {
  Button,
  ButtonElementTypes,
  ButtonSkinTertiary,
} from '@picsart/design-system/components/Button';
import Title from '@picsart/growth-rc/Title';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import { useTranslator } from '@picsart/rc/services/localization';
import { useState } from 'react';
import SimilarPageItem from './SimilarPageItem';
import useStyles from './styles';
import { ExploreSimilarPagesProps } from './types';

function ExploreSimilarPages({ title, buttonLabel, pageItems }: ExploreSimilarPagesProps) {
  const translate = useTranslator();
  const styles = useStyles();
  const sliceLength = 8;
  const [slicedTools, setSlicedTools] = useState(sliceLength);
  const isShowMoreVisible = pageItems?.slice(0, slicedTools)?.length < pageItems?.length;
  return (
    <HorizontalContainer className={styles.container}>
      <section className={styles.wrapper} data-pulse-section-group="all-tools-section">
        <Title className={styles.title} {...title} />
        <div className={styles.grid}>
          {pageItems.slice(0, slicedTools).map(item => (
            <SimilarPageItem {...item} key={item.description} />
          ))}
        </div>
        {isShowMoreVisible && (
          <Button
            tag={ButtonElementTypes.Button}
            skin={ButtonSkinTertiary}
            className={styles.button}
            data-pulse-name={buttonLabel}
            onClick={() => setSlicedTools(prev => prev + sliceLength)}
          >
            {translate(buttonLabel)}
          </Button>
        )}
      </section>
    </HorizontalContainer>
  );
}

export default ExploreSimilarPages;
